import {
  HttpClient,
  HttpClientModule,
  HTTP_INTERCEPTORS,
} from "@angular/common/http";
import { ErrorHandler, NgModule } from "@angular/core";
import { BrowserModule } from "@angular/platform-browser";
import { IonicStorageModule, Storage } from "@ionic/storage";
import { CacheModule } from "ionic-cache";
import {
  TranslateLoader,
  TranslateModule,
  TranslateService,
} from "@ngx-translate/core";
import { TranslateHttpLoader } from "@ngx-translate/http-loader";
import { IonicApp, IonicErrorHandler, IonicModule } from "ionic-angular";

import { Autostart } from "@ionic-native/autostart";
import { BackgroundMode } from "@ionic-native/background-mode";
import { Camera } from "@ionic-native/camera";
import { Deeplinks } from "@ionic-native/deeplinks";
import { Device } from "@ionic-native/device";
import { Geolocation } from "@ionic-native/geolocation";
import { Insomnia } from "@ionic-native/insomnia";
import { LocalNotifications } from "@ionic-native/local-notifications";
import { NativeAudio } from "@ionic-native/native-audio";
import { Network } from "@ionic-native/network";
import { SplashScreen } from "@ionic-native/splash-screen";
import { StatusBar } from "@ionic-native/status-bar";

import { Items } from "../mocks/providers/items";
import { Settings, User, Api, SocketService } from "../providers";
import { MyApp } from "./app.component";
import { AuthService } from "../providers/api/auth.service";
import { UserService } from "../providers/api/user.service";
import { ActuatorService } from "../providers/api/actuator.service";
import { ApartmentService } from "../providers/api/apartment.service";
import { BuildingService } from "../providers/api/building.service";
import { DeviceService } from "../providers/device/device.service";
import { GroupService } from "../providers/api/group.service";
import { MeasureService } from "../providers/api/measure.service";
import { NodeService } from "../providers/api/node.service";
import { NotificationService } from "../providers/api/notification.service";
import { RoomService } from "../providers/api/room.service";
import { RuleService } from "../providers/api/rule.service";
import { ScenesService } from "../providers/api/scenes.service";
import { ApiNew } from "../providers/api/api-new";
import { RequestInterceptorService } from "../providers/api/request-interceptor.service";
import { ComponentsModule } from "../components/components.module";
import { WeatherProvider } from "../providers/weather/weather";
import { NodePeriodicityProvider } from "../providers/node-periodicity/node-periodicity";
import { DoorBellProvider } from "../providers/door-bell/door-bell";
import { PanicProvider } from "../providers/panic/panic";
import { NewsProvider } from "../providers/news/news";
import { TransportsProvider } from "../providers/transports/transports";
import { NodeAvailabilityProvider } from "../providers/node-availability/node-availability";
import { SmokeProvider } from "../providers/smoke/smoke";
import { UnknowFailureProvider } from "../providers/unknow-failure/unknow-failure";
import { OfflineProvider } from "../providers/offline/offline";
import { UserStorage } from "../providers/user/user-storage";
import { CookieService } from "ngx-cookie-service";

// The translate loader needs to know where to load i18n files
// in Ionic's static asset pipeline.
export function createTranslateLoader(http: HttpClient) {
  return new TranslateHttpLoader(http, "./assets/i18n/", ".json");
}

export function provideSettings(storage: Storage, translate: TranslateService) {
  /**
   * The Settings provider takes a set of default settings for your app.
   *
   * You can add new settings options at any time. Once the settings are saved,
   * these values will not overwrite the saved values (this can be done manually if desired).
   */
  return new Settings(storage, {
    option1: true,
    option2: "Ionitron J. Framework",
    option3: "3",
    option4: "Hello",
  });
}

@NgModule({
  declarations: [MyApp],
  imports: [
    BrowserModule,
    HttpClientModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: createTranslateLoader,
        deps: [HttpClient],
      },
    }),
    ComponentsModule,
    IonicModule.forRoot(MyApp, {
      preloadModules: true,
    }),
    CacheModule.forRoot(),
    IonicStorageModule.forRoot(),
  ],
  bootstrap: [IonicApp],
  entryComponents: [MyApp],
  providers: [
    //Native
    Autostart,
    BackgroundMode,
    Camera,
    Deeplinks,
    Device,
    Insomnia,
    LocalNotifications,
    NativeAudio,
    Network,
    SplashScreen,
    StatusBar,
    Geolocation,

    //App
    Api,
    ApiNew,
    Items,
    User,

    //Providers App
    AuthService,
    UserService,
    DeviceService,
    GroupService,
    MeasureService,
    BuildingService,
    ApartmentService,
    RoomService,
    NodeService,
    NotificationService,
    SocketService,
    ActuatorService,
    CookieService,
    UserStorage,
    RuleService,
    ScenesService,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: RequestInterceptorService,
      multi: true,
    },
    {
      provide: Settings,
      useFactory: provideSettings,
      deps: [Storage],
    },
    // Keep this to enable Ionic's runtime error handling during development
    {
      provide: ErrorHandler,
      useClass: IonicErrorHandler,
    },
    WeatherProvider,
    NodePeriodicityProvider,
    DoorBellProvider,
    PanicProvider,
    NewsProvider,
    TransportsProvider,
    NodeAvailabilityProvider,
    SmokeProvider,
    OfflineProvider,
    UnknowFailureProvider,
  ],
})
export class AppModule {}



// WEBPACK FOOTER //
// ./src/app/app.module.ts